import { Action } from '../actions/station-info';

const defaultState = {};

export default function geocodeReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.StationInfo.StationSearchCompleted:
      return {
        ...state,
        [body.trendsKey]: body.location,
      };

    default:
      return state;
  }
}
